import {BackendApi} from '@/services/backend_api'

export default {
  get (id) {
    return BackendApi.getAnonymousClient().get(`news/${id}`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  cget () {
    return BackendApi.getAnonymousClient().get(`news/`)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  post (news) {
    return BackendApi.getClient().post('news/', news)
    .then(response => { return response })
    .catch(e => { throw e })
  },
  put (news) {
    return BackendApi.getClient().put(`news/${news.id}`, news)
    .then(response => { return response })
    .catch(e => { throw e })
  }
}



// WEBPACK FOOTER //
// ./src/services/resource_client/news.js